@if (bontonPanel.isB2B()) {
<div class="flex flex-col flex-auto min-w-0 min-h-[calc(100vh-16rem)]">
    <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg -mt-20 shadow pb-5 relative"
        [class]="!wlSettingsDetails.is_wl ? 'pb-7' : ''">
        <div class="flex flex-row space-x-3 mt-3 mb-5">
            <div class="flex flex-row items-center w-full">
                <div class="flex flex-col min-w-[33%] max-w-[33%] p-3 field-blue-bg rounded-lg -mr-3 cursor-pointer"
                    (click)="openfromCitySelect()">
                    <span class="text-gray text-md">From</span>
                    <mat-select #fromCitySelect formControlName="sourceId" [compareWith]="compareWith"
                        class="font-semibold">
                        <mat-option>
                            <ngx-mat-select-search placeholderLabel="Search"
                                noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (ct of fromCityList | async; track ct) {
                        <mat-option [value]="ct">{{ct.display_name}}</mat-option>
                        }
                    </mat-select>
                </div>
                <div (click)="switch()"
                    class="flex flex-row justify-center items-center w-9 h-9 white-bg rounded-full z-20 cursor-pointer"
                    [matTooltip]="'Switch'">
                    <mat-icon svgIcon="heroicons_outline:arrows-right-left" class="primary-text icon-size-4"></mat-icon>
                </div>
                <div class="flex flex-col min-w-[33%] max-w-[33%] p-3 field-blue-bg rounded-lg -ml-3 cursor-pointer"
                    (click)="opentoCitySelect()">
                    <span class="text-gray text-md">To</span>
                    <mat-select #toCitySelect formControlName="destinationId" [compareWith]="compareWith"
                        class="font-semibold">
                        <mat-option>
                            <ngx-mat-select-search placeholderLabel="Search"
                                noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (ct of toCityList | async; track ct) {
                        <mat-option [value]="ct">{{ct.display_name}}</mat-option>
                        }
                    </mat-select>
                </div>
                <div class="flex flex-col w-[33%] field-blue-bg rounded-lg p-3 ml-3 cursor-pointer"
                    (click)="picker.open()">
                    <span class="text-gray text-md">Date</span>
                    <div class="flex flex-row">
                        <input class="font-semibold" [min]="minDate" [readonly]="true" [matDatepicker]="picker"
                            formControlName="dateOfJourny" />
                    </div>
                    <mat-datepicker #picker></mat-datepicker>
                </div>
            </div>
        </div>
        @if(!wlSettingsDetails.is_wl){
        <div class="flex justify-end absolute right-4 bottom-2" (click)="helpVideo('Bus')">
            <div class="flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer hover:bg-[#E8F1F8]">
                <span class="font-medium primary-text text-sm">NEED HELP?</span>
                <mat-icon svgIcon="youtube" class="icon-size-5"></mat-icon>
            </div>
        </div>
        }

        <div class="flex flex-row justify-center items-center space-x-4"
            [class]="!wlSettingsDetails.is_wl ? '-mb-13 mt-2' : '-mb-11'">
            <button mat-flat-button class="primary-bg w-50 min-h-13 rounded-lg" (click)="detail()">
                <span class="text-white font-semibold text-lg">Search</span>
            </button>
        </div>
    </form>
    <!-- RECENT BUS SEARCH -->
    @if (recentBusSearchList?.length > 0) {
    <div class="flex flex-col mt-15 space-y-3">
        <div class="pb-1">
            <div class="text-2xl font-bold">Recent Bus Search</div>
            <div class="text-sm text-gray">Compare your search history with starting price</div>
        </div>
        <div class="grid grid-cols-3 gap-4">
            @for (rf of recentBusSearchList; track rf) {
            <div class="flex flex-row space-x-2 white-bg w-full px-4 py-3 items-center rounded-lg shadow cursor-pointer"
                (click)="recentSearch(rf)">
                <div class="w-16">
                    <div class="w-[50px] bg-lightsky h-[50px] p-2 flex justify-center items-center rounded-full">
                        <img loading="lazy" src="/assets/images/bus/bus.svg" class="h-6" />
                    </div>
                </div>
                <div class="h-[80%] border-r border-gray-border"></div>
                <div class="flex flex-col  space-y-1 w-[calc(100%-50px)]">
                    <div class="flex flex-row items-center space-x-4 font-medium text-[#131313] text-lg">
                        <span>{{ rf.source }}</span>
                        <img loading="lazy" class="mx-1 w-auto rounded-[10px]"
                            src="assets/images/temp_images/bus_icons/bus_routes_destination.webp">
                        <span>{{ rf.destination }}</span>
                    </div>
                    <div class="flex flex-row justify-between">
                        <span class="text-[#696969] text-base font-medium">{{ rf.dateOfOrg | date :
                            "dd-MM-yyyy"}}</span>
                        <div>
                            <span class="pl-[40px] text-[#234977] text-sm font-normal pt-[2px]">Fare starting at</span>
                            <span class="pl-[6px] text-[#234977] text-base font-semibold">{{ rf.currency }} {{
                                rf.busRate }}</span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    }
    @if (settings?.data?.android_app_link || settings?.data?.ios_app_link) {
    <div class="bg-add mt-13 shadow rounded-xl h-[257px]">
        <div class="flex items-center justify-end h-full">
            <div class="flex flex-col gap-3 w-[710px] h-full justify-center">
                <p class="text-[18px] font-normal text-[#c6c6c6] max-w-[400px]">Get access to all Major Travel Services
                    like Flights,
                    Hotels, Bus, Holidays, and Visas at your Fingertips!</p>
                <div class="flex flex-row gap-3.5">
                    @if (settings?.data?.ios_app_link) {
                    <img loading="lazy" src="assets/images/image/app_store.webp" class="w-[150px] cursor-pointer"
                        alt="app_store" (click)="openNewWindow(settings?.data?.ios_app_link)">
                    }
                    @if (settings?.data?.android_app_link) {
                    <img loading="lazy" src="assets/images/image/google_play.webp" class="w-[170px] cursor-pointer"
                        alt="google_play" (click)="openNewWindow(settings?.data?.android_app_link)">
                    }
                </div>
            </div>
        </div>
    </div>
    }
    <!-- FAQS -->
    <div class="flex flex-col mt-10 mb-8 space-y-3">
        <span class="text-xl font-bold primary-text">Bus Booking FAQ</span>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. How can I manage bulk bookings for a group of travellers?</span>
            <span class="text-gray">A. You can easily manage group bookings by contacting our dedicated support
                team. We offer personalized assistance to ensure a seamless travel experience for your group.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. Can I customize bus routes or request specific pick-up/drop-off points for my
                clients?</span>
            <span class="text-gray">A. Absolutely! We understand the importance of customized routes. Contact our
                customer support to discuss your specific requirements, and we will work with you to create a tailored
                solution.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. How does your platform ensure the safety and reliability of bus services for
                our clients?</span>
            <span class="text-gray">A. Safety is our top priority. We partner with trusted bus operators who adhere
                to strict safety standards. Additionally, we provide real-time tracking, ensuring your clients' journeys
                are safe and reliable.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. What reporting and analytics tools do you offer for tracking booking trends
                and expenses?</span>
            <span class="text-gray">A. We provide advanced reporting and analytics tools to help you track booking
                trends, analyze expenses, and optimize your bus travel management. Stay informed and make data-driven
                decisions with our comprehensive tools.</span>
        </div>
    </div>
</div>
} @else {
<!--Theme 1-->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme1) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[21rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-68px] relative z-[99]">
            <div class="m-auto rounded-[10px] w-full flex">
                <form [formGroup]="formGroup" class="flex flex-col rounded-[10px] w-full">
                    <div class="flex flex-row shadow-xl w-full white-bg overflow-hidden rounded-[10px]">
                        <div class="flex flex-row w-full">
                            <div class="flex flex-col min-w-[36%] max-w-[36%] border-r pt-[25px] pb-[32px] pr-1 gray-border pl-[25px] cursor-pointer"
                                [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''" (click)="from.open()">
                                <div>
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                    <div class="pt-3">
                                        <mat-select class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'from'" [compareWith]="compareWith" #from
                                            formControlName="sourceId">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search Destination"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="fromCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of fromCityList | async; track ct) {
                                            <mat-option [value]="ct">
                                                <div class="flex flex-col h-15 justify-center cst-new">
                                                    {{ ct.display_name }}
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="relative w-9">
                                <div (click)="switch()"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[37px] -left-[18px]"
                                    [matTooltip]="'Switch'">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>
                            <div class="flex flex-col min-w-[36%] max-w-[36%] border-r py-[25px] pr-1 gray-border pl-[22px] -ml-2 cursor-pointer"
                                [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''" (click)="to.open()">
                                <div>
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                    <div class="pt-3">
                                        <mat-select class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'to'" [compareWith]="compareWith" #to
                                            formControlName="destinationId">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search Destination"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="toCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of toCityList | async; track ct) {
                                            <mat-option [value]="ct">
                                                <div class="flex flex-col h-15 justify-center cst-new">
                                                    {{ ct.display_name }}
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col pl-[15px] min-w-[12.5%] max-w-[12.5%]"
                                [ngClass]="selectedField == 'date' ? 'secondary-bg' : ''"
                                (click)="picker.open();selectedField = 'date'">
                                <div class="ml-[7px] py-[25px]">
                                    <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                        <span class="pt-1 pb-1 pr-1">
                                            <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon"></span>
                                        <span class="ml-0 pr-3 pt-[2px] text-secondary">Date</span>
                                    </mat-label>
                                    <input readonly
                                        class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]" matInput
                                        [matDatepicker]="picker" [min]="minDate"
                                        (click)="picker.open();selectedField = 'date'" formControlName="dateOfJourny">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        class="hidden"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            <div class="w-full h-full justify-center flex items-center">
                                <button class="primary-bg rounded-lg py-10 px-12" mat-flat-button (click)="detail()">
                                    <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
<!-- Theme 2 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme2) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[15px] mt-[-110px]">
        <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 pt-6 white-bg rounded-[15px] shadow-xl pb-5">
                <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%]">
                        <div class="flex flex-col w-full h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg mr-[-12px] cursor-pointer"
                            [ngClass]="selectedField == 'from' ? 'primary-border' : 'gray-border'"
                            (click)="from.open()">
                            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
                                [ngClass]="selectedField == 'from' ? 'primary-text' : 'text-secondary'">From</span>
                            <mat-select (click)="selectedField = 'from'" #from
                                class="mt-1 pl-2 font-bold font-Roboto text-2xl theme-black-text"
                                [compareWith]="compareWith" formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 min-w-9 border gray-border white-bg rounded-full z-20 cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col w-full h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg ml-[-12px] cursor-pointer"
                            [ngClass]="selectedField == 'to' ? 'primary-border' : 'gray-border'" (click)="to.open()">
                            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
                                [ngClass]="selectedField == 'to' ? 'primary-text' : 'text-secondary'">To</span>
                            <mat-select (click)="selectedField = 'to'" #to
                                class="mt-1 pl-2 font-bold font-Roboto text-2xl theme-black-text"
                                [compareWith]="compareWith" formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    <div [ngClass]="selectedField == 'dateOfJourny' ? 'primary-border' : 'gray-border'"
                        class="flex flex-col w-[20%] ml-[7px] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2 cursor-pointer"
                        (click)="picker.open();selectedField = 'dateOfJourny'">
                        <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
                            [ngClass]="selectedField == 'dateOfJourny' ? 'primary-text' : 'text-secondary'">Date</span>
                        <div class="flex flex-row pl-3">
                            <input class="font-bold text-2xl font-Roboto w-full theme-black-text mt-1" [min]="minDate"
                                (click)="picker.open(); selectedField = 'dateOfJourny'" [readonly]="true"
                                [matDatepicker]="picker" formControlName="dateOfJourny" />
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-center mb-[-45px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-semibold text-2xl font-Inter">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 3 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme3) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[18.5rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-75px]">
        <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg shadow-xl pb-5">
                <div class="flex flex-row w-full space-x-3 gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%]">
                        <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 secondary-bg rounded-lg -mr-3 cursor-pointer"
                            (click)="from.open()">
                            <span
                                class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select class="mt-1 pl-2 font-semibold text-xl" [compareWith]="compareWith" #from
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()"
                            class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full z-20 border-white cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 px-2 rounded-lg secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                            (click)="to.open()">
                            <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select class="font-semibold pl-2 text-xl mt-1" [compareWith]="compareWith" #to
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    <div class="flex flex-col w-[20%] h-[74px] secondary-bg rounded-lg px-4 py-2.5 cursor-pointer"
                        (click)="picker.open()">
                        <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Date</span>
                        <div class="flex flex-row">
                            <input class="font-semibold text-xl mt-1 min-w-[12rem]" [min]="minDate"
                                (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                formControlName="dateOfJourny" />
                            <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                                (click)="picker.open()"></mat-icon>
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-center -mb-11 space-x-4">
                    <button mat-flat-button class="w-50 min-h-13 rounded-lg primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 4 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme4) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-95px]">
        <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[22px] shadow-xl pb-5">
                <div class="flex flex-row w-full space-x-3 gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%]">
                        <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3  pr-2 pl-[16px] -mr-3 cursor-pointer"
                            (click)="from.open()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select class="mt-1 pr-2 font-semibold text-xl" [compareWith]="compareWith" #from
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        <div (click)="switch()"
                            class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full z-20 border-white cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 pl-8 pr-2 -mr-3 ml-[-12px] cursor-pointer"
                            (click)="to.open()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select class="font-semibold text-xl mt-1" [compareWith]="compareWith" #to
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                    </div>
                    <div class="flex flex-col w-[20%] h-[74px] px-4 py-2.5 cursor-pointer" (click)="picker.open()">
                        <span class="max-w-max text-secondary text-lg font-normal">Date</span>
                        <div class="flex flex-row">
                            <input class="font-semibold text-xl mt-1 min-w-[19rem]" [min]="minDate"
                                (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                formControlName="dateOfJourny" />
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                        <div class="gray-border mt-[3px] w-full border-t-2"></div>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-center -mb-[47px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 5 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme5) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-row bg-center justify-center items-center bg-no-repeat h-[540px] primary-bg w-full"
        style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
background-color: #000000b3 !important;">
        <div class="flex flex-row gap-6 min-w-[1260px] max-w-[1260px] h-full">
            <div class="flex flex-col h-full items-center justify-center w-1/2">
                <div class="flex flex-col gap-[2px]">
                    <div class="flex">
                        <h1
                            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                            {{busData?.title}}</h1>
                    </div>
                    <div class="flex text-base justify-center font-Inter white-text">
                        <div class="text-center w-[500px] z-[99] textNote4 font-normal gray-text">
                            {{busData?.description}}</div>
                    </div>
                </div>
            </div>
            <div class="w-1/2 h-full flex flex-col">
                <form [formGroup]="formGroup"
                    class="flex flex-col h-full w-full justify-center gap-3 theme5-form-field">
                    <div class="flex flex-col white-bg rounded-lg shadow-xl p-5 w-full gap-5">
                        <div class="flex flex-row gap-3 w-full">
                            <mat-form-field class="w-full">
                                <mat-label class="text-secondary text-base font-normal">From</mat-label>
                                <mat-select class="font-medium text-[15px] text-black pr-1 max-w-[230px]"
                                    [compareWith]="compareWith" formControlName="sourceId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="fromCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of fromCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span class="font-normal text-base">
                                                {{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                            </mat-form-field>
                            <div class="relative">
                                <div (click)="switch()" [matTooltip]="'Switch'"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[28px] -left-[18px]">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>
                            <mat-form-field class="w-full">
                                <mat-label class="text-secondary text-base font-normal">To</mat-label>
                                <mat-select class="font-medium text-[15px] text-black pr-1 max-w-[230px]"
                                    [compareWith]="compareWith" formControlName="destinationId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span class="font-normal text-base">
                                                {{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                            </mat-form-field>
                        </div>
                        <mat-form-field class="w-full">
                            <mat-label class="text-secondary text-base font-normal">Date</mat-label>
                            <input matInput class="font-medium text-[15px] text-black" [min]="minDate"
                                (click)="picker2.open()" [readonly]="true" [matDatepicker]="picker2"
                                formControlName="dateOfJourny" />
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                                (click)="picker2.open()"></mat-icon>
                        </mat-form-field>
                        <div class="flex justify-center items-center py-1">
                            <button mat-flat-button class="w-full py-[26px] rounded-lg primary-bg" (click)="detail()">
                                <span class="white-text font-medium text-[17px]">Search</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
<!--Theme 6 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme6) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[18rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-62px] relative z-[99]">
            <div class="m-auto rounded-[10px] w-full flex">
                <form [formGroup]="formGroup" class="flex flex-col rounded-[10px] w-full">
                    <div class="flex flex-row shadow-xl w-full white-bg overflow-hidden rounded-[65px] h-[100px]">
                        <div class="flex flex-row w-full">
                            <div class="flex flex-col min-w-[35%] max-w-[35%] border-r pr-1 gray-border pl-13 justify-center cursor-pointer"
                                [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''" (click)="from.open()">
                                <div>
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                    <div class="pt-1">
                                        <mat-select class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'from'" [compareWith]="compareWith" #from
                                            formControlName="sourceId">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search Destination"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="fromCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of fromCityList | async; track ct) {
                                            <mat-option [value]="ct">
                                                <div class="flex flex-col h-15 justify-center cst-new">
                                                    {{ ct.display_name }}
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="relative w-9">
                                <div (click)="switch()"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[37px] -left-[18px]"
                                    [matTooltip]="'Switch'">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>
                            <div class="flex flex-col min-w-[35%] max-w-[35%] border-r pr-1 gray-border pl-[22px] -ml-2 justify-center cursor-pointer"
                                [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''" (click)="to.open()">
                                <div>
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                    <div class="pt-1">
                                        <mat-select class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'to'" [compareWith]="compareWith" #to
                                            formControlName="destinationId">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search Destination"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="toCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of toCityList | async; track ct) {
                                            <mat-option [value]="ct">
                                                <div class="flex flex-col h-15 justify-center cst-new">
                                                    {{ ct.display_name }}
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col pl-[11px] min-w-[14%] max-w-[14%] justify-center cursor-pointer"
                                [ngClass]="selectedField == 'date' ? 'secondary-bg' : ''"
                                (click)="picker.open();selectedField = 'date'">
                                <div class="">
                                    <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                        <span class="pt-1 pb-1 pr-1">
                                            <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon"></span>
                                        <span class="ml-0 pr-3 pt-[2px] text-secondary">Date</span>
                                    </mat-label>
                                    <input readonly
                                        class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]"
                                        matInput [matDatepicker]="picker" [min]="minDate"
                                        (click)="picker.open();selectedField = 'date'" formControlName="dateOfJourny">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        class="hidden"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            <div class="w-full h-full justify-end pr-5 flex items-center">
                                <button class="primary-bg rounded-full py-8 px-13" mat-flat-button (click)="detail()">
                                    <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
<!-- Theme 7 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme7) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden h-[635px] relative">
    <div class="absolute top-[-73px] w-full h-[710px] z-10"
        [style]="'background-image: url('+busData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[14rem] mt-[73px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
        <div class="mr-6 rounded-b-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-row p-5 pb-1.5 pt-2 white-bg rounded-b-xl shadow-xl theme7-form-field">
                <div class="flex flex-row w-full gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-full">
                        <mat-form-field class="min-w-[50%] max-w-[50%] -mr-3">
                            <mat-label class="text-secondary text-lg font-normal">From</mat-label>
                            <mat-select class="font-medium text-[17px] h-[60px]" [compareWith]="compareWith"
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 bg-white border-2 mt-[23px] rounded-full z-20 gray-border cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <mat-form-field class="min-w-[50%] max-w-[50%] -mr-3 ml-[-12px]">
                            <mat-label class="text-secondary text-lg font-normal">To</mat-label>
                            <mat-select class="font-medium text-[17px] h-[60px]" [compareWith]="compareWith"
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-form-field class="w-[15%] min-w-[15%] pl-3 pr-1">
                        <mat-label class="text-secondary text-lg font-normal">Date</mat-label>
                        <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDate"
                            (click)="picker2.open()" [readonly]="true" [matDatepicker]="picker2"
                            formControlName="dateOfJourny" />
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                    <div class="flex justify-center items-end">
                        <button mat-flat-button class="w-36 min-h-[65px] rounded-lg primary-bg" (click)="detail()">
                            <span class="white-text font-medium text-2xl">Search</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 8 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme8) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden h-[575px] relative">
    <div class="absolute top-[-73px] w-full h-[650px] z-10"
        [style]="'background-image: url('+busData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[120px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[41px] justify-center font-normal leading-[65px] white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-100px]">
        <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-row bg-[#0a0707ab] border light-border px-5 py-6 rounded-2xl">
                <div class="flex flex-row w-full white-bg overflow-hidden rounded-[5px]">
                    <div class="flex flex-row w-full">
                        <div class="flex flex-col min-w-[36%] max-w-[36%] justify-center border-r pr-1 gray-border pl-[25px] cursor-pointer"
                            [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''" (click)="from.open()">
                            <div>
                                <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                <div class="pt-1">
                                    <mat-select class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'from'" [compareWith]="compareWith" #from
                                        formControlName="sourceId">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search Destination"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="fromCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of fromCityList | async; track ct) {
                                        <mat-option [value]="ct">
                                            <div class="flex flex-col h-15 justify-center cst-new">
                                                {{ ct.display_name }}
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="relative w-9">
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border absolute top-[22px] -left-[18px]"
                                [matTooltip]="'Switch'">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <div class="flex flex-col min-w-[36%] max-w-[36%] border-r justify-center pr-1 gray-border pl-[22px] -ml-2 cursor-pointer"
                            [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''" (click)="to.open()">
                            <div>
                                <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                <div class="pt-1">
                                    <mat-select class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'to'" [compareWith]="compareWith" #to
                                        formControlName="destinationId">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search Destination"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="toCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of toCityList | async; track ct) {
                                        <mat-option [value]="ct">
                                            <div class="flex flex-col h-15 justify-center cst-new">
                                                {{ ct.display_name }}
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col pl-[15px] min-w-[12.5%] max-w-[12.5%] justify-center cursor-pointer"
                            [ngClass]="selectedField == 'date' ? 'secondary-bg' : ''"
                            (click)="picker.open();selectedField = 'date'">
                            <div class="ml-[7px]">
                                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                    <span class="pt-1 pb-1 pr-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </span>
                                    <span
                                        class="pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Date</span>
                                </mat-label>
                                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                    matInput [matDatepicker]="picker" [min]="minDate"
                                    (click)="picker.open();selectedField = 'date'" formControlName="dateOfJourny">
                                <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                        </div>
                        <div class="h-[75px] min-h-[75px] w-[192px] min-w-[192px] justify-end flex items-center">
                            <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full" mat-flat-button
                                (click)="detail()">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 9 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme9) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden h-[635px]">
    <div class="absolute top-[-73px] w-full h-[600px] z-10"
        [style]="'background-image: url('+busData?.background_image+');background-blend-mode: color !important; background-color: #000000bd !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[352px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1 class="text-center text-[46px] justify-center font-semibold white-text flex w-full z-[99]">
                        {{busData?.title}}
                    </h1>
                </div>
                <div class="flex text-xl justify-center font-normal font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px]">
        <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[12px] shadow-xl pb-5">
                <div class="flex flex-row w-full space-x-3 gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%]">
                        <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3  pr-2 pl-[16px] -mr-3 cursor-pointer"
                            (click)="from.open()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select class="mt-1 pr-2 font-medium text-xl" [compareWith]="compareWith" #from
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 bg-white border-2 mt-[23px] rounded-full z-20 gray-border cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 pl-8 pr-2 -mr-3 ml-[-12px] cursor-pointer"
                            (click)="to.open()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select class="font-medium text-xl mt-1" [compareWith]="compareWith" #to
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                    </div>
                    <div class="flex flex-col w-[20%] h-[74px] px-4 py-2.5 cursor-pointer" (click)="picker.open()">
                        <span class="max-w-max text-secondary text-lg font-normal">Date</span>
                        <div class="flex flex-row">
                            <input class="font-medium text-xl mt-1 min-w-[19rem]" [min]="minDate"
                                (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                formControlName="dateOfJourny" />
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                        <div class="gray-border mt-[3px] w-full border-t-2"></div>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-center -mb-[42px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 10 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme10) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden relative">
    <div class="absolute top-0 w-full h-[375px] flex flex-row items-end">
        <div class="w-full min-h-full h-full relative">
            <div style="background-image: url(assets/images/b2c/theme_10_header_img.svg);
                background-repeat: no-repeat;
                background-position: right;
                background-size: cover;" class="z-10 min-h-full h-full w-[55%] absolute top-0 left-0"></div>
            <img loading="lazy" [src]="busData?.background_image" alt="background_image"
                class="object-cover bg-left h-full w-1/2 absolute top-0 right-0">
        </div>
    </div>
    <div class="flex flex-col bg-no-repeat h-[375px] bg-[#F9F9F9] w-full gray-text">
        <div class="flex flex-col min-w-[1260px] max-w-[1260px] m-auto h-full items-center justify-center">
            <div class="flex flex-col w-full">
                <div class="flex">
                    <h1
                        class="text-[52px] justify-start font-bold font-Dosis theme-black-text flex w-[50%] z-[99] pr-2">
                        {{busData?.title}}
                    </h1>
                </div>
                <div class="flex text-xl justify-start font-Ibm_Plex_Sans_Devanagari theme-black-text w-[50%] pr-2">
                    <div class="w-full z-[99] textNote4">
                        {{busData?.description}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-40px]">
        <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-row white-bg rounded-[5px] overflow-hidden shadow-xl">
                <div class="flex flex-row w-full overflow-hidden rounded-[5px] white-bg">
                    <div class="flex flex-row w-full">
                        <div class="flex flex-col min-w-[36%] max-w-[36%] justify-center border-r pr-1 gray-border pl-[25px] cursor-pointer"
                            [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''" (click)="from.open()">
                            <div>
                                <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                <div class="pt-1">
                                    <mat-select class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'from'" [compareWith]="compareWith" #from
                                        formControlName="sourceId">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search Destination"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="fromCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of fromCityList | async; track ct) {
                                        <mat-option [value]="ct">
                                            <div class="flex flex-col h-15 justify-center cst-new">
                                                {{ ct.display_name }}
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="relative w-9">
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border absolute top-[22px] -left-[18px]"
                                [matTooltip]="'Switch'">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <div class="flex flex-col min-w-[36%] max-w-[36%] border-r justify-center pr-1 gray-border pl-[22px] -ml-2 cursor-pointer"
                            [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''" (click)="to.open()">
                            <div>
                                <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                <div class="pt-1">
                                    <mat-select class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'to'" [compareWith]="compareWith" #to
                                        formControlName="destinationId">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search Destination"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="toCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of toCityList | async; track ct) {
                                        <mat-option [value]="ct">
                                            <div class="flex flex-col h-15 justify-center cst-new">
                                                {{ ct.display_name }}
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col pl-[15px] min-w-[12.5%] max-w-[12.5%] justify-center cursor-pointer"
                            [ngClass]="selectedField == 'date' ? 'secondary-bg' : ''"
                            (click)="picker.open();selectedField = 'date'">
                            <div class="ml-[7px]">
                                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                    <span class="pt-1 pb-1 pr-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </span>
                                    <span
                                        class="pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Date</span>
                                </mat-label>
                                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                    matInput [matDatepicker]="picker" [min]="minDate"
                                    (click)="picker.open();selectedField = 'date'" formControlName="dateOfJourny">
                                <mat-datepicker-toggle matSuffix [for]="picker" class="hidden"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                        </div>
                        <div class="h-[75px] min-h-[75px] w-[192px] min-w-[192px] justify-end flex items-center">
                            <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full" mat-flat-button
                                (click)="detail()">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 11 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme11) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden xl:px-10 px-0">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[580px] xl:rounded-[30px] rounded-none primary-bg w-full gray-text"
        style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
     background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] flex rounded-xl mt-[-300px]">
        <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 pt-18 white-bg pb-[18px] rounded-lg shadow-xl">
                <div class="flex flex-row w-full space-x-3 gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%]">
                        <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] -mr-3 cursor-pointer"
                            (click)="from.open()">
                            <span
                                class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select class="mt-1 pl-2 font-semibold text-xl" [compareWith]="compareWith" #from
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()"
                            class="flex flex-row justify-center items-center w-8 h-8 bg-white rounded-full z-20 cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 px-2 rounded-[4px] secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                            (click)="to.open()">
                            <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select class="font-semibold pl-2 text-xl mt-1" [compareWith]="compareWith" #to
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    <div class="flex flex-col w-[20%] h-[74px] secondary-bg rounded-[4px] px-4 py-2.5 cursor-pointer"
                        (click)="picker.open()">
                        <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Date</span>
                        <div class="flex flex-row">
                            <input class="font-semibold text-xl mt-1 min-w-[12rem]" [min]="minDate"
                                (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                formControlName="dateOfJourny" />
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-center -mb-11 pt-[20px] space-x-4">
                    <button mat-flat-button class="w-64 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 12 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme12) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden h-[595px] relative">
    <div class="absolute top-[-73px] w-full h-[670px] z-10"
        [style]="'background-image: url('+busData?.background_image+');background-blend-mode: color !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[11rem] mt-[73px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[42px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote3">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
        <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-row p-5 pt-3 pb-2.5 bg-[#000000bd] rounded-xl shadow-xl theme12-form-field">
                <div class="flex flex-row w-full gap-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-full gap-1.5">
                        <mat-form-field class="w-full">
                            <mat-label class="text-[15px] text-white font-normal">From</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-5px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <mat-form-field class="w-full">
                            <mat-label class="text-[15px] text-white font-normal">To</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                    </div>
                    <mat-form-field class="w-[20%] min-w-[20%] pr-1">
                        <mat-label class="text-white text-base font-normal">Date</mat-label>
                        <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate"
                            (click)="picker2.open()" [readonly]="true" [matDatepicker]="picker2"
                            formControlName="dateOfJourny" />
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                            (click)="picker2.open()"></mat-icon>
                    </mat-form-field>
                    <div class="flex justify-center items-end">
                        <button mat-flat-button
                            class="w-[70px] min-w-[70px] min-h-[60px] rounded-lg primary-bg text-white"
                            (click)="detail()">
                            <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 13 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme13) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[560px] primary-bg w-full gray-text" style="border-bottom-left-radius: 100% 250px;
     border-bottom-right-radius: 100% 250px;
     border-bottom: 14px solid white;
     background-color: #0000007a !important;
     background-image: url('{{busData?.background_image}}');
     background-blend-mode: color !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[30rem]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[50px] font-semibold font-[cursive] white-text flex w-full z-[99] tracking-[7px]">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-[30px] font-extralight pt-3 font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="w-[1000px] z-[99] textNote4 leading-[35px]">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px] mt-[-145px]">
        <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-col px-5 pt-3 white-bg rounded-[12px] shadow-xl pb-5 theme12-form-field">
                <div class="flex flex-row w-full gap-4 mt-3 mb-7">
                    <div class="flex flex-row items-center w-full gap-2">
                        <mat-form-field class="w-full">
                            <mat-label class="text-[16px] unselected-text font-normal">From</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon matPrefix svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-5px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <mat-form-field class="w-full">
                            <mat-label class="text-[16px] unselected-text font-normal">To</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] pr-1" [compareWith]="compareWith"
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon matPrefix svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                    </div>
                    <mat-form-field class="w-[20%] min-w-[20%] pr-1">
                        <mat-label class="unselected-text text-[16px] font-normal">Date</mat-label>
                        <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate"
                            (click)="picker2.open()" [readonly]="true" [matDatepicker]="picker2"
                            formControlName="dateOfJourny" />
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
                            (click)="picker2.open()"></mat-icon>
                    </mat-form-field>
                </div>
                <div class="flex flex-row justify-center items-center -mb-[50px] space-x-4">
                    <button mat-flat-button class="w-64 min-h-[60px] rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 14 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme14) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[510px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[24rem] pt-[70px]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[48px] font-medium white-text w-full z-[99]" style="font-family: sans-serif;">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-[22px] font-normal font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="w-[650px] z-[99] textNote4">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex mt-[-61px]">
        <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] rounded-t-none white-bg shadow-xl">
            <form [formGroup]="formGroup" class="flex flex-col border-t-2 pt-4 pb-2">
                <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
                    <div class="flex flex-row items-center w-[80%] border-[1px] rounded-[10px] gray-border">
                        <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 pl-2 pr-[18px] border-r-[1px] gray-border cursor-pointer"
                            (click)="from.open()">
                            <span class="pl-1.5 max-w-max text-base font-medium text-secondary">From</span>
                            <mat-select class="mt-1 pl-1.5 font-semibold text-lg" [compareWith]="compareWith" #from
                                formControlName="sourceId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base">
                                            {{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-16px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>

                        <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 pr-2 pl-[18px] cursor-pointer"
                            (click)="to.open()">
                            <span class="pl-1.5 max-w-max text-base font-medium text-secondary">To</span>
                            <mat-select class="font-semibold text-lg pl-1.5 mt-1" [compareWith]="compareWith" #to
                                formControlName="destinationId">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [value]="ct">
                                    <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span
                                            class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    <div class="flex flex-col w-[20%] h-[74px] border-[1px] rounded-[10px] gray-border p-3 cursor-pointer"
                        (click)="picker.open()">
                        <div
                            class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                            <span class="font-medium text-secondary">Date</span>
                            <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                                (click)="picker.open()"></mat-icon>
                        </div>
                        <div class="flex flex-row">
                            <input class="font-semibold text-lg mt-1.5 min-w-[12rem]" [min]="minDate"
                                (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                formControlName="dateOfJourny" />
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                    <div class="flex flex-row justify-center items-end">
                        <button mat-flat-button
                            class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white"
                            (click)="detail()">
                            <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!-- Theme 15 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme15) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[48px] text-center font-semibold white-text w-full z-[99]"
                        style="font-family: sans-serif;">
                        {{busData?.title}}</h1>
                </div>
                <div class="flex text-[20px] white-text justify-center">
                    <div class="w-[900px] z-[99] font-light textNote2 text-center">
                        {{busData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
        <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
            <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] white-bg shadow-xl"
                [ngClass]="{ 'rounded-tl-none' : isFirstService }">
                <form [formGroup]="formGroup" class="flex flex-col pt-6 pb-2">
                    <div class="flex flex-row w-full gap-3 mt-3 mb-5">
                        <div class="flex flex-row items-center w-[75%]">
                            <div class="flex flex-col min-w-[50%] max-w-[50%] h-[74px] py-3 px-2 border gray-border rounded-xl -mr-3 cursor-pointer"
                                (click)="from.open()">
                                <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">From</span>
                                <mat-select class="mt-1 pl-2 font-semibold text-lg" [compareWith]="compareWith" #from
                                    formControlName="sourceId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="fromCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of fromCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span class="font-normal text-base">
                                                {{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center w-9 h-9 border gray-border rounded-full z-20 bg-white cursor-pointer">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                            <div class="flex flex-col min-w-[50%] h-[74px] max-w-[50%] py-3 px-2 border gray-border rounded-xl -mr-3 ml-[-12px] cursor-pointer"
                                (click)="to.open()">
                                <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">To</span>
                                <mat-select class="font-semibold pl-2 text-lg mt-1" [compareWith]="compareWith" #to
                                    formControlName="destinationId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span
                                                class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                        <div class="flex flex-col w-[20%] h-[74px] border gray-border rounded-xl px-4 py-2.5 ml-3 cursor-pointer"
                            (click)="picker.open()">
                            <span class="max-w-max text-secondary text-[15px] font-normal">Date</span>
                            <div class="flex flex-row">
                                <input class="font-semibold text-lg mt-1 min-w-[12.5rem]" [min]="minDate"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="dateOfJourny" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        <div class="flex flex-row justify-center items-center">
                            <button mat-flat-button class="w-[130px] min-h-18 rounded-xl primary-bg" (click)="detail()">
                                <span class="white-text font-medium text-2xl">Search</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
<!-- Theme 16 -->
@if (busData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme16) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{busData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
            <div class="flex flex-col justify-start min-w-[1260px] max-w-[1260px]">
                <h1 class="text-[48px] font-semibold white-text w-full z-[99] uppercase"
                    style="font-family: 'Mina'; text-shadow: 2px 2px 4px rgba(0,0,0,0.4);">
                    {{busData?.title}}
                </h1>
                <div class="w-[900px] z-[99] text-[20px] white-text font-light textNote2"
                    style="text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
                    {{busData?.description}}
                </div>
            </div>
        </div>
    </div>
    <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
        <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
            <div class="min-w-[1260px] max-w-[1260px] bg-white/40 p-6 w-full backdrop-blur-md rounded-[20px] shadow-xl">
                <form [formGroup]="formGroup" class="flex flex-col">
                    <div class="flex flex-row w-full space-x-3">
                        <div class="flex flex-row items-center w-full">
                            <div class="flex flex-col min-w-[414px] max-w-[414px] h-[74px] py-3 px-2 white-bg rounded-2xl custom-bus-right-circle -mr-3 cursor-pointer"
                                (click)="from.open()">
                                <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">From</span>
                                <mat-select class="mt-1 pl-2 font-semibold text-lg" [compareWith]="compareWith" #from
                                    formControlName="sourceId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="fromCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of fromCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span class="font-normal text-base">
                                                {{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center w-9 h-9 border gray-border rounded-full z-20 bg-white cursor-pointer">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                            <div class="flex flex-col min-w-[414px] h-[74px] max-w-[414px] py-3 px-3 white-bg rounded-2xl custom-bus-left-circle ml-[-14px] cursor-pointer"
                                (click)="to.open()">
                                <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">To</span>
                                <mat-select class="font-semibold pl-2 text-lg mt-1" [compareWith]="compareWith" #to
                                    formControlName="destinationId">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [value]="ct">
                                        <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                            <span
                                                class="font-normal font-Roboto text-base text-[#1C1C1C]">{{ct.display_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                        <div class="flex flex-col h-[74px] w-full white-bg rounded-2xl px-4 py-2.5 cursor-pointer"
                            (click)="picker.open()">
                            <span class="max-w-max text-secondary text-[15px] font-normal">Date</span>
                            <div class="flex flex-row">
                                <input class="font-semibold text-lg mt-1 min-w-[12.5rem]" [min]="minDate"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="dateOfJourny" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        <div class="flex flex-row justify-center items-start">
                            <button mat-flat-button class="rounded-xl min-h-[74px] primary-bg" (click)="detail()">
                                <mat-icon class="text-white invert w-8 h-8" svgIcon="feather:search"></mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
}